import type { ProfileDetails } from '../types/hr';

// Richer, hand-authored detail for featured sample profiles (fictional).
export const profileOverrides: Record<string, Partial<ProfileDetails>> = {
  e3: {
    address: { street1: '100 Example Ave', street2: 'Unit 3C', city: 'Sampletown', state: 'NY', zip: '11000', country: 'United States' },
    homePhone: '(718) 555-0143',
    homeEmail: 'marcus.bell@home-demo.example.com',
    social: {
      linkedin: 'linkedin.com/in/marcus-bell-demo',
      facebook: 'facebook.com/marcus.bell.demo',
      instagram: 'instagram.com/marcusbell.demo',
    },
    education: [
      { id: 'ed1', institution: 'Sampletown State University', degree: "Bachelor's", major: 'Finance', gpa: '3.6', start: '2006', end: '2010' },
      { id: 'ed2', institution: 'Example Community College', degree: "Associate's", major: 'Business Administration', gpa: '3.8', start: '2004', end: '2006' },
    ],
    eeoCategory: 'Sales Workers',
    veteran: ['Armed Forces Service Medal Veteran'],
    compensationModel: 'Base + Commission',
    nmls: '000000-DEMO',
    employmentStatus: [
      { date: 'Jun 14, 2021', status: 'Full-Time', comment: 'Completed 90-day introductory period' },
      { date: 'Mar 14, 2021', status: 'Introductory', comment: 'New hire' },
    ],
    compensation: [
      { date: 'Jan 1, 2026', schedule: 'Semi-monthly', payType: 'Salary', rate: '$58,000.00 / yr', overtime: 'Exempt', otRate: '—', reason: 'Merit increase', comment: 'Annual review — 3.5%' },
      { date: 'Jan 1, 2024', schedule: 'Semi-monthly', payType: 'Salary', rate: '$56,000.00 / yr', overtime: 'Exempt', otRate: '—', reason: 'Promotion', comment: 'Promoted to Senior Loan Officer' },
      { date: 'Mar 14, 2021', schedule: 'Semi-monthly', payType: 'Salary', rate: '$52,000.00 / yr', overtime: 'Exempt', otRate: '—', reason: 'New hire', comment: '—' },
    ],
    jobInfo: [
      { date: 'Jan 1, 2024', location: 'Branch – East', division: 'Retail Lending', department: 'Sales', teams: 'Purchase Team A', title: 'Senior Loan Officer', reportsTo: 'Avery Lindqvist' },
      { date: 'Mar 14, 2021', location: 'Main Office', division: 'Retail Lending', department: 'Sales', teams: 'Purchase Team A', title: 'Loan Officer', reportsTo: 'Avery Lindqvist' },
    ],
    commission: [
      { date: 'Oct 31, 2026', amount: '$4,250.00', comment: 'October funded volume' },
      { date: 'Sep 30, 2026', amount: '$3,980.00', comment: 'September funded volume' },
      { date: 'Aug 31, 2026', amount: '$5,120.00', comment: 'August funded volume' },
    ],
    potentialBonus: [{ percent: '5%', amount: '$2,900.00' }],
    bonus: [{ date: 'Dec 15, 2025', amount: '$1,500.00', reason: 'Year-end performance', comment: 'Top producer, Q4' }],
    equity: [],
  },
};
